import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';
import Icon from './svg/blank.svg?react';

export const BlankIcon: FC<SvgIconProps> = props => <SvgIcon component={Icon} {...props} />;
